import React, { FC, useContext, useEffect, useMemo, useState } from 'react';
import { EndOfSeasonSnapshots, getSnapshotData, Snapshot } from '../../scripts/dataSources/snapshots';
import LoadingPage from '../common/LoadingPage';
import ModeSelector from '../common/modeSelector/ModeSelector';
import { DataContext } from '../context/dataLoader/DataLoader';
import WinsOver500Chart from './chart/WinsOver500Chart';

import './WinsOver500.scss';


const WinsOver500: FC = () => {


    useEffect(() => {
        //alert("Some game data (for games 46/47/48) is currently unavailable. \nUse your imagination to fill in the gaps. Okay?")
    }, [])


    const { allGames, snapshots, teamCollections, simModel } = useContext(DataContext);

    const snapMap = useMemo(() => {
        let map: Record<string, Snapshot | undefined> = {};
        EndOfSeasonSnapshots.forEach((snapshot) => {
            map[snapshot.name] = snapshot;
        });
        map["Current data"] = undefined;
        return map;
    }, [])

    const currentSeasonIsActive = simModel?.simData.currentDay !== -1;

    const snapOptions = useMemo(() => {
        if (currentSeasonIsActive) {
            return EndOfSeasonSnapshots.map(snap => snap.name).concat("Current data")

        }
        return EndOfSeasonSnapshots.map(snap => snap.name)
    }, [currentSeasonIsActive])


    const [currentSnapName, setCurrentSnapName] = useState<string>("Current data")
    const currentSnapshot = snapMap[currentSnapName];

    const snapshotData = getSnapshotData(currentSnapshot, snapshots);

    const gamesToUse = snapshotData ? snapshotData.games : allGames?.currentSeasonGames;

    if (!teamCollections || !gamesToUse || !simModel) {
        return <LoadingPage />
    }


    if (!currentSeasonIsActive && !snapshotData) {
        if (snapshots) {
            setCurrentSnapName(EndOfSeasonSnapshots[EndOfSeasonSnapshots.length - 1].name)
        }
        return <LoadingPage>Loading previous seasons...</LoadingPage>
    }

    const teamsToUse = snapshotData ? snapshotData.teamCollections.allTeams : teamCollections.allTeams;
    const currentDay = (snapshotData ? snapshotData.simData : simModel).simData.currentDay;

    const conferences = simModel.simData.currentLeagueData.subLeagues.map(subleague => {
        const adjective = subleague.divisions[0].name.split(" ")[1];
        return { name: `The Conference of ${adjective}`, divisions: subleague.divisions.map(division => division.id) }
    })

    return <div className='Page'>
        <div>
            <ModeSelector options={snapOptions} currentSelection={currentSnapName} setter={setCurrentSnapName} />
            {
                currentDay > -2 ?
                    conferences.map((conference, idx) => {
                        const teams = teamsToUse.filter(team => conference.divisions.includes(team.division.id));
                        teams.sort((a, b) => (b.standings[0] ?? b.standings).wins - (a.standings[0] ?? a.standings).wins)
                        return (
                            <WinsOver500Chart title={conference.name} teams={teams} games={gamesToUse} currentDay={currentDay} key={idx} />
                        )
                    })
                    : <div>No games yet...</div>
            }
        </div>
    </div>
}

export default WinsOver500;